import * as yup from 'yup';

export const workbenchNameRules = {
  max: 255,
  pattern: /^[A-Za-z0-9\s_.:/=+\-@]*$/,
} as const;

export const MAX_DESCRIPTION_LENGTH = 256;

export const workbenchSchema: yup.AnyObjectSchema = yup
  .object({
    name: yup
      .string()
      .transform((v) => (typeof v === 'string' ? v.trim() : v))
      .max(workbenchNameRules.max, `Workbench name should contain up to ${workbenchNameRules.max} characters`)
      .matches(
        workbenchNameRules.pattern,
        'Only spaces, alphanumeric and the following special characters are allowed: _ . : / = + - @',
      )
      .required('Workbench name is a required field'),
    description: yup
      .string()
      .transform((v) => (typeof v === 'string' ? v.trim() : v))
      .max(256, 'Description should contain up to 256 characters')
      .required('Description is a required field'),
    workbenchGroup: yup.string().required('Workbench group is a required field'),
    instance_type: yup.string().required('Instance type is a required field'),
  })
  .required();
